<template>
<div class="content-i">
  <div class="content-box">
    <div class="row">
      <div class="col-lg">
        <div class="element-wrapper">
            <h6 class="element-header">Agendamentos</h6>
            <div class="element-box">
              <form>
                <h5 class="form-header">
                  Gerenciar Agenda do Profissional
                </h5>
                <div class="form-desc">
                  Autorize, Cancele, Remarque consultas de seus profissionais.
                </div>
                <div class="form-group">
                  <label for="">Profissional</label>
                  <select class="form-control" name="profissional" id="profissional" v-model="profissional">
                    <option :value="null">Selecione um profissional</option>
                    <option v-for="prof in profissionais" :key="prof._id" :value="prof" >{{prof.nome}} ({{prof.especialidade.nome}})</option>
                  </select>
                </div>

                <div class="row" v-if="profissional">
                  <div class="col-sm-4">
                    <datepicker :disabledDates="disabled" @selected="selectAtendimento" :language="locale" format="DD/MM/YYYY" :inline="true"></datepicker>
                  </div>
                  <div class="col-sm-8">
                    <div class="row">
                      <h6 v-if="dataSelecionada" class="element-header">Data: {{getDataFormatada(new Date(dataSelecionada))}}</h6>
                      <h6 v-else class="element-header">Selecione uma data no calendario ao lado</h6>
                      <div v-if="dataSelecionada" class="table-responsive">
                        <table class="table table-padded">
                          <thead>
                            <tr>
                              <th>
                                Horário
                              </th>
                              <th>
                                Cliente
                              </th>
                              <th class="text-center">
                                Status
                              </th>
                              <th class="text-center">
                                Ação
                              </th>
                              <th>
                                
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="horarioAtendimento in atendimento.horarios" :key="horarioAtendimento.horario">
                              <td>{{horarioAtendimento.horario}}</td>
                              <td>{{getCliente(horarioAtendimento)}}</td>
                              <td class="nowrap">
                                <span v-if="horarioAtendimento.agendamento" class="status-pill smaller"
                                 :class="classAtendimento(horarioAtendimento)"></span>
                                {{getStatus(horarioAtendimento)}}
                              </td>
                              <td class="row-actions">
                                <a v-if="horarioAtendimento.agendamento && horarioAtendimento.agendamento.status === 'AGUARDANDO_CONFIRMACAO'"
                                  @click="modalConfirmarAgendamento(horarioAtendimento)"
                                  title="Confirmar agendamento" style="color: green; cursor: pointer">
                                  <i class="fas fa-calendar-check"></i>
                                </a>
                                <a v-if="horarioAtendimento.agendamento"
                                  title="Reagendar agendamento" style="color: #f8bc34; cursor: pointer">
                                  <i class="fas fa-calendar-plus"></i>
                                </a>
                                <a v-if="horarioAtendimento.agendamento && horarioAtendimento.agendamento.status !== 'CANCELADA'"
                                  @click="modalCancelarAgendamento(horarioAtendimento)"
                                  title="Cancelar agendamento" style="color: red; cursor: pointer">
                                  <i class="fas fa-ban"></i>
                                </a>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

              </form>
            </div>
          </div>
      </div>
    </div>
  
  
  </div>

  <div class="modal" id="confirmModal" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Confirmar Agendamento</h4>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        <div class="modal-body">
          <div class="container-fluid" v-if="horarioAtendimentoSelect">
            <div class="row">
              <div class="col-md-4">
                <span>Profissional: </span>
              </div>
              <div class="col-md-8">
                {{horarioAtendimentoSelect.agendamento.corpoClinico.nome}}
              </div>
            </div>

            <div class="row">
              <div class="col-md-6">
                Data/Hora: {{horarioAtendimentoSelect.agendamento.dataEscolhida}} {{horarioAtendimentoSelect.agendamento.horarioEscolhido}}
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
          <button type="button" class="btn btn-success" @click="confirmarAgendamento">Confirmar agendamento</button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal" id="cancelModal" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Cancelar Agendamento</h4>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        <div class="modal-body">
          <p>Deseja realmente cancelar o agendamento?</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Não</button>
          <button type="button" @click="cancelarAgendamento" class="btn btn-primary">Sim</button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal" id="reagendarModal" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Confirmar Agendamento</h4>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        <div class="modal-body">
          
        </div>
      </div>
    </div>
  </div>

</div>
  
</template>
<script>
import _ from 'lodash'
import Datepicker from 'vuejs-datepicker'
import moment from 'moment'
import {ptBR} from 'vuejs-datepicker/dist/locale'

export default {
  created () {
    moment.locale('pt-br')
    this.$store.dispatch('buscaProfissionais', '')
      .then(profissionais => {
        this.profissionais = profissionais
      })
  },
  components: {
    Datepicker
  },
  computed: {
    disabled () {
      let dates = this.agenda.map(agenda => agenda.dataFormatada)
      return {
        customPredictor: date => {
          const d = moment(date).format('DD/MM/YYYY')
          if (dates.indexOf(d) < 0) {
            return true
          }
        }
      }
    }
  },
  watch: {
    'profissional' (profissional) {
      this.agenda = []
      this.dataSelecionada = null
      this.atendimento = null
      if (profissional) {
        this.$store.dispatch('findAgendaProfissionalCompleta', this.profissional)
          .then(agenda => {
            this.agenda = agenda
            if (this.agenda.length === 0) {
              this.$nextTick(() => {
                alert('Configure a agenda do profissional no Módulo Cadastro de Profissional')
              })
            }
          })
      }
    }
  },
  data () {
    return {
      locale: ptBR,
      profissionais: [],
      profissional: null,
      agenda: [],
      dataSelecionada: null,
      atendimento: null,
      horarioAtendimentoSelect: null
    }
  },
  methods: {
    onSearchProfissional (search, loading) {
      loading(true)
      this.searchProfissional(loading, search, this)
    },
    searchProfissional: _.debounce((loading, search, vm) => {
      vm.$store.dispatch('buscaProfissionais', search)
        .then(profissionais => {
          loading(false)
          vm.profissionais = profissionais
        })
    }, 350),

    async selectAtendimento (data) {
      this.agenda = await this.$store.dispatch('findAgendaProfissionalCompleta', this.profissional)
      this.dataSelecionada = data
      this.atendimento = this.agenda.find(agenda => agenda.dataFormatada === this.getDataFormatada(data))
    },

    getDataFormatada (date) {
      return moment(date).format('DD/MM/YYYY')
    },

    getCliente (horarioAtendimento) {
      if (horarioAtendimento.agendamento) {
        return horarioAtendimento.agendamento.user.name
      }
    },

    getStatus (horarioAtendimento) {
      if (horarioAtendimento.agendamento) {
        switch (horarioAtendimento.agendamento.status) {
          case 'AGUARDANDO_CONFIRMACAO':
            return 'Aguardando Confirmação'
          case 'CONFIRMADA':
            return 'Confirmado'
          case 'CANCELADA':
            return 'Cancelada'
        }
      }
    },

    classAtendimento (horarioAtendimento) {
      return {
        'yellow': horarioAtendimento.agendamento && horarioAtendimento.agendamento.status === 'AGUARDANDO_CONFIRMACAO',
        'green': horarioAtendimento.agendamento && horarioAtendimento.agendamento.status === 'CONFIRMADA',
        'red': horarioAtendimento.agendamento && horarioAtendimento.agendamento.status === 'CANCELADA'
      }
    },

    modalConfirmarAgendamento (horarioAtendimento) {
      this.horarioAtendimentoSelect = horarioAtendimento
      this.$nextTick(() => {
        window.jQuery('#confirmModal').modal('show')
      })
    },

    confirmarAgendamento () {
      this.$store.dispatch('confirmarAgendamento', this.horarioAtendimentoSelect.agendamento)
        .then(agendamento => {
          window.jQuery('#confirmModal').modal('hide')
          this.$store.dispatch('findAgendaProfissionalCompleta', this.profissional)
            .then(agenda => {
              this.agenda = agenda
              this.atendimento = this.agenda.find(agenda => agenda.dataFormatada === this.getDataFormatada(this.dataSelecionada))
            })
        })
    },

    modalCancelarAgendamento (horarioAtendimento) {
      this.horarioAtendimentoSelect = horarioAtendimento
      this.$nextTick(() => {
        window.jQuery('#cancelModal').modal('show')
      })
    },

    cancelarAgendamento () {
      this.$store.dispatch('cancelarAgendamento', this.horarioAtendimentoSelect.agendamento)
        .then(agendamento => {
          window.jQuery('#cancelModal').modal('hide')
          this.$store.dispatch('findAgendaProfissionalCompleta', this.profissional)
            .then(agenda => {
              this.agenda = agenda
              this.atendimento = this.agenda.find(agenda => agenda.dataFormatada === this.getDataFormatada(this.dataSelecionada))
            })
        })
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/pages/dashboard/agendamento/Agendamento.vue